import { useQuery } from 'react-query';
import { api } from '../../../static/api';
import { ApiFeaturesResponse, ApiGameListItem, IGameListItem } from '../../../types/ApiTypes';
import { QueryAliases } from '../../../types/QueryAliases';
import { transformGameListItem } from '../../../utils/api/dataTransformers/transformGame/transformGameListItem';
import useAxiosInstance from '../../axios/useAxiosInstance';

interface UseHistoryGamesProps {
  page?: number;
  limit?: number;
}

const useHistoryGames = ({ page, limit }: UseHistoryGamesProps = {}) => {
  const axiosInstance = useAxiosInstance();

  const { data, refetch, isSuccess, isLoading, isError } = useQuery(
    [QueryAliases.HISTORY_GAMES, page ?? '', limit ?? ''],
    () =>
      axiosInstance.get(api.endpoints.HISTORY_GAMES, {
        params: { page, limit },
      }),
  );

  const apiGames: ApiFeaturesResponse<ApiGameListItem[]> | undefined = data?.data;

  const games: ApiFeaturesResponse<IGameListItem[]> | undefined = !!apiGames
    ? {
        count: apiGames.count,
        data: apiGames.data.map(game => transformGameListItem(game)),
      }
    : undefined;

  return {
    games,
    refetch,
    isSuccess,
    isLoading,
    isError,
  };
};

export default useHistoryGames;
